import { useTranslation } from "react-i18next"

/**
 * Convenience wrapper around useTranslation.
 *
 * Usage:
 *   const { t } = useT()             // uses the "common" namespace
 *   const { t } = useT("messages")   // uses the "messages" namespace
 *
 * In the JSX you then write  t("key")  or  t("key", { name: "value" })
 */
export default function useT(ns) {
  return useTranslation(ns)
}
